<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2></h2>

    <kendo-tabstrip>
      <kendo-tabstrip-tab [title]="t('generalInformation')" [selected]="true">
        <ng-template kendoTabContent>
          <app-employee-edit
            [employee]="vm.employee"
          >
          </app-employee-edit>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab
        [title]="t('roles')"
        [selected]="false"
        [disabled]="!vm.employee?.id"
      >
        <ng-template 
          kendoTabContent
          *ngIf="('Permissions.UserRoles.Update' | permission)"
          >
          <app-employee-role></app-employee-role>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab
        [title]="t('worktime')"
        [selected]="false"
        [disabled]="!vm.employee?.id"
        *ngIf="('Permissions.WorkTimes.Create' | permission)"
      >
        <ng-template kendoTabContent>
          <app-employee-work-time></app-employee-work-time>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab
        [title]="t('fiscal-year-report')"
        [selected]="false"
        [disabled]="!vm.employee?.id"
        *ngIf="('Permissions.FiscalYears.Search' | permission)"
      >
        <ng-template kendoTabContent>
          <app-employee-fiscal-year-report></app-employee-fiscal-year-report>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab 
        *permissionIf="'Permissions.Attachments.Search'"
        [title]="t('attachments')"
        [disabled]="!vm.employee?.id"
      >
        <ng-template kendoTabContent>
          <app-attachments [employeeId]="vm.employee?.id"></app-attachments>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </ng-container>
</ng-container>
